import OAuthCallback from '../../../components/OAuthCallback.jsx';

const GoogleOAuthCallback = ({}) => {
    return <OAuthCallback route="/api/calendars/google/oauth" />;
};

export default GoogleOAuthCallback;
